<div class="pagination-bar">
  <span class="pagination-info">
    Showing <strong>{{ rangeStart }}–{{ rangeEnd }}</strong> of <strong>{{ totalItems }}</strong>
  </span>

  <div class="pagination-controls">
    <button type="button" class="page-btn nav-btn" [disabled]="currentPage === 1" (click)="prev()">
      <i class="bi bi-chevron-left"></i>
    </button>

    @for (page of pages; track $index) {
      @if (page === '...') {
        <span class="page-ellipsis">…</span>
      } @else {
        <button type="button" class="page-btn" [class.active]="page === currentPage" (click)="goTo(page)">
          {{ page }}
        </button>
      }
    }

    <button type="button" class="page-btn nav-btn" [disabled]="currentPage === totalPages" (click)="next()">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
</div>
